import React from 'react'

const termOptions = [
	{
		value: 24,
		name: '2 years (24 mo.)',
	},
	{
		value: 36,
		name: '3 years (36 mo.)',
	},
	{
		value: 48,
		name: '4 years (48 mo.)',
	},
	{
		value: 60,
		name: '5 years (60 mo.)',
	},
	{
		value: 72,
		name: '6 years (72 mo.)',
	},
	{
		value: 84,
		name: '7 years (84 mo.)',
	},
	{
		value: 96,
		name: '8 years (96 mo.)',
	},
	{
		value: 108,
		name: '9 years (108 mo.)',
	},
	{
		value: 120,
		name: '10 years (120 mo.)',
	},
	{
		value: 144,
		name: '12 years (144 mo.)',
	},
]

const InputTerms = ({ name, loanPurposeId, onChange, style }) => {
	const handleChange = (e) => {
		onChange(e.target.name, e.target.value)
	}

	const renderTermOptions = () => {
		if (loanPurposeId === '3') {
			return termOptions.slice(0, 5)
		}
		return termOptions
	}
	return (
		<div className='form-group'>
			<label>Length of Loan</label>
			<select
				className='form-control form-control-lg'
				name={name}
				onChange={handleChange}
				style={style}
			>
				<option value=''>Please select a term</option>
				{renderTermOptions().map((option) => (
					<option key={option.value} value={option.value}>
						{option.name}
					</option>
				))}
			</select>
		</div>
	)
}

export default InputTerms
